"use strict";
/*
 * Created on 01 25 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var SelloutCategoryDiscount_1 = require("./SelloutCategoryDiscount");
/**
 * @author Jaroslav Sevcik
 */


var SelloutSubSettings =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutSubSettings, _DomainObject_1$Domai);

  function SelloutSubSettings(remodelingDaysBeforeClosure, categoryDiscounts) {
    var _this;

    _classCallCheck(this, SelloutSubSettings);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutSubSettings).call(this));
    _this.remodelingDaysBeforeClosure = remodelingDaysBeforeClosure;
    _this.categoryDiscounts = categoryDiscounts;
    return _this;
  }

  return SelloutSubSettings;
}(DomainObject_1.DomainObject);

exports.SelloutSubSettings = SelloutSubSettings;

SelloutSubSettings.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutSubSettings.name);
  return {
    remodelingDaysBeforeClosure: builder.opt(builder.num('remodelingDaysBeforeClosure')),
    categoryDiscounts: builder.opt(builder.listOf(builder.obj('categoryDiscounts', SelloutCategoryDiscount_1.SelloutCategoryDiscount.schema, function (mat) {
      return new SelloutCategoryDiscount_1.SelloutCategoryDiscount(mat.cmCategoryId, mat.discount1, mat.discount2);
    })))
  };
}();